import { Component, OnInit, Input } from '@angular/core';

import { getParams } from '../../../utils/utils.object';
import { brandFooterDefaultOptions, cachedPath } from '../syndicated-options';
import { SyndicatedOptions } from '../syndicated-options.interface';
import { SYNDICATED_FOOTER_ANIMATIONS } from '../syndicated-footer/syndicated-footer.animations';

import { LocaleHandler } from '../../../libraries/locale-handler/locale-handler';
import { ConfigService } from '../../../services/config/config.service';
import { Constants } from '../../../constants';

@Component({
  selector: 'app-pep-syndicated-footer',
  templateUrl: './syndicated-footer.component.html',
  styleUrls: ['./syndicated-footer.component.scss'],
  animations: [...SYNDICATED_FOOTER_ANIMATIONS]
})
export class SyndicatedFooterComponent implements OnInit {
  /**
   * Application configuration object
   * @var {any}
   */
  private _config: any;

  public syndicatedFooterUrl: string;
  public defaultOptions: SyndicatedOptions;
  public useCached = false;
  public stateName: string;
  public showLine = false;
  public siteId = '';

  constructor(
    private _localeHandler: LocaleHandler,
    private _configService: ConfigService
  ) {
    this._config = this._configService.getConfig();
  }

  ngOnInit() {
    const footerRetrievedConfig = this._config.hasOwnProperty('syndicatedConfig')
      ? this._config.syndicatedConfig
      : null,
      basePath = `${footerRetrievedConfig.baseUrl}${footerRetrievedConfig.footer.path}`;

    this.defaultOptions = footerRetrievedConfig.siteId
      ? { ...brandFooterDefaultOptions[footerRetrievedConfig.siteId ] }
      : { ...brandFooterDefaultOptions['dlr'] };

    this.defaultOptions.version = footerRetrievedConfig.footer.version || this.defaultOptions.version;
    this.defaultOptions.locale = this._localeHandler.getCurrentLocale() || this.defaultOptions.locale;
    this.defaultOptions.language = this._localeHandler.getCurrentLanguage() || this.defaultOptions.language;
    this.defaultOptions.content = footerRetrievedConfig.footer.content || this.defaultOptions.content;
    this.defaultOptions.siteOverride = footerRetrievedConfig.siteId || this.defaultOptions.siteOverride;
    this.syndicatedFooterUrl = `${basePath}${this.useCached ? cachedPath : '/'}${getParams(this.defaultOptions)}`;
    this.stateName = 'loaded';
  }

  footerStateDone(event: AnimationEvent) {
    this.showLine = true;
    // We want to make sure that the animation is complete and the style has been set
    // by the animation module. Once that is done we can manually remove the style attr.
    setTimeout(() => {
      event['element'].removeAttribute('style');
    });
  }
}
